import { del, get, post, put } from "../../services/ApiRouting";

// Function to fetch all certs
export async function getAllCerts(page = 1) {
  try {
    const response = await get(`${API_URL}/crud/certs?page=${page}`);
    return response;
  } catch (error) {
    console.error("Error fetching certs:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to create a new certificat
export async function createCerts(certificatData) {
  try {
    const response = await post(`${API_URL}/crud/certs`, certificatData);
    return response;
  } catch (error) {
    console.error("Error creating certificat:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to fetch a single certificat by ID
export async function getCertsById(certificatId) {
  try {
    const response = await axios.get(`${API_URL}/crud/certs/${certificatId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching certificat with ID ${certificatId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to update an existing certificat
export async function updateCerts(certificatId, certificatData) {
  try {
    const response = await put(
      `${API_URL}/crud/certs/${certificatId}`,
      certificatData
    );
    return response;
  } catch (error) {
    console.error(`Error updating certificat with ID ${certificatId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to delete a certificat
export async function deleteCerts(certificatId) {
  try {
    const response = await del(`${API_URL}/crud/certs/${certificatId}`);
    return response;
  } catch (error) {
    console.error(`Error deleting certificat with ID ${certificatId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}
